import { INQUIRY_TYPE } from '@/app/donation/constants';

export const INQUIRY_DETAIL_TYPE = {
  PRODUCT_INFO: 'PRODUCT_INFO',
  DELIVERY: 'DELIVERY',
  DEFECT: 'DEFECT',
  ETC: 'ETC',
} as const;

const INQUIRY_DETAIL_TYPE_LABEL = {
  [INQUIRY_DETAIL_TYPE.PRODUCT_INFO]: '상품 정보',
  [INQUIRY_DETAIL_TYPE.DELIVERY]: '배송 문의',
  [INQUIRY_DETAIL_TYPE.DEFECT]: '불량/파손 문의',
  [INQUIRY_DETAIL_TYPE.ETC]: '기타 문의',
} as const;

export const INQUIRY_DETAIL_TYPE_OPTIONS_MAP = {
  [INQUIRY_TYPE.GIFT_PRODUCT]: Object.entries(INQUIRY_DETAIL_TYPE).map(
    ([, value]) => {
      return {
        label: INQUIRY_DETAIL_TYPE_LABEL[value],
        value: value,
      };
    },
  ),
  [INQUIRY_TYPE.DELIVERY]: [],
  [INQUIRY_TYPE.ETC]: [],
};
